import * as yup from 'yup';

export const appointmentRescheduleSchema = yup.object().shape({
  //   date: yup.string().nullable().required('Please select date'),
  time: yup.string().required('Please select time'),
});
